var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$store.state.session.currency_symbol)}}),(_vm.type == 'total')?_c('span',[_vm._v(_vm._s(_vm.display_value.integer)+"."),_c('span',{staticClass:"price-fraction"},[_vm._v(_vm._s(_vm.display_value.fraction))])]):_c('span',[_vm._v(_vm._s(_vm.display_value.total))])])
}
var staticRenderFns = []

export { render, staticRenderFns }